import { APIResponse, NameDataSource } from '@app/core.model';

export interface CouponResponse extends APIResponse {
  coupons: Array<NameDataSource>;
}
export interface CategoryResponse extends APIResponse {
  doctorCategories: Array<NameDataSource>;
}
export interface Coupon {
  id?: string;
  name: string;
  couponType: CouponType;
  expiredAt?: Date;
  value: number;
  maxDiscount?: number;
  description?: string;
  maximumUsers?: number;
  usage?: CouponUsage[];
}
export enum CouponType {
  Percentage = 1,
  Fixed = 2,
}

export enum CouponUsage {
  Appointment = 1,
  Pharmacy = 2,
  Service = 3,
  Packages = 4,
  StoreBill = 5,
}
